@if (isFormInitialised) {
  <div
    class="filter"
    [ngClass]="{'filter--map': isMapView()}">
    <!-- Header -->
    <div class="filter-header"
      [ngClass]="{'filter-header--map': isMapView()}">
      <div class="filter-header-title">{{'FILTER' | translate}}</div>
      <div class="filter-header-container">
        @if (hasClickedApplyFilterButton) {
          <mat-progress-spinner
            color="primary"
            mode="indeterminate"
            diameter="16">
          </mat-progress-spinner>
        }
        <button mat-button
          color="primary"
          [ngClass]="{'filter-header-container-action--map': isMapView()}"
          [disabled]="hasClickedApplyFilterButton"
          (click)="hasClickedApplyFilterButton ? null : onClickSubmit(); clickSubmit.emit()">
          <fa-icon icon="check"></fa-icon>
          {{'APPLY' | translate}}
        </button>
        <button mat-button
          color="primary"
          [ngClass]="{'filter-header-container-action--map': isMapView()}"
          [disabled]="hasClickedApplyFilterButton"
          (click)="hasClickedApplyFilterButton ? null : resetFilters(); clickSubmit.emit()">
          <fa-icon icon="undo"></fa-icon>{{'CLEAR' | translate}}
        </button>
        @if (!isMapView() && !hideCollapseButton) {
          <button
            mat-button
            color="primary"
            (click)="displayOrHideFiltersPanel()">
            <fa-icon [ngClass]="{'rotate': !displayFiltersPanel}"
              class="animation-rotate"
            icon="angle-down"></fa-icon>
            {{ (displayFiltersPanel ? 'VIEW_LESS' : 'VIEW_MORE') | translate }}
          </button>
        }
      </div>
    </div>
    <!-- Form -->
    <form class="filter-form"
      [formGroup]="dynamicFilterForm"
      (ngSubmit)="onClickSubmit()"
      [@detailExpand]="displayFiltersPanel ? 'expanded' : 'collapsed'">
      <div class="filter-form-container">
        @for (entry of filterFormEntries; track trackByName($index, entry)) {
          <!-- Auto Complete Fields -->
          @if (entry.type === 'autoComplete') {
            <mat-form-field appearance="outline"
              class="filter-form-container-field">
              <mat-label>{{entry.placeholder | translate}}
                {{multiselect.value?.length ? " - " + multiselect.value.length + " " + ("OPTIONS_SELECTED" |
                translate) :
              ''}}</mat-label>
              <mat-select (openedChange)="onOpenSelect($event, entry)"
                [formControlName]="entry.name"
                multiple
                #multiselect
                (selectionChange)="selected(entry, $event)"
                matTooltipClass="multiline-tooltip"
                [matTooltip]="multiselect.value?.map ? (multiselect.value | extractPropertyPipe:'value':entry.translationRequired | join:'') : ''"
                [compareWith]="selectOptionCompare">
                <mat-option>
                  <ngx-mat-select-search [placeholderLabel]="'SEARCH' | translate"
                    [formControl]="searchFieldControls.controls[entry.name]"
                    [noEntriesFoundLabel]="'NO_OPTIONS_FOUND' | translate"
                    [searching]="filterAutocompleteLoaders[entry.name]"
                    [showToggleAllCheckbox]="true"
                    [toggleAllCheckboxChecked]="getAllAutocompleteOptions(entry) | listSelectionCheckboxState: dynamicFilterForm.controls[entry.name].value: ListSelectionState.all"
                    [toggleAllCheckboxIndeterminate]="getAllAutocompleteOptions(entry) | listSelectionCheckboxState: dynamicFilterForm.controls[entry.name].value: ListSelectionState.partial"
                    (toggleAll)="toggleAll($event, entry)">
                  </ngx-mat-select-search>
                </mat-option>
                <div [appHidden]="filterAutocompleteLoaders[entry.name]">
                  @for (option of (filteredDataForAutocomplete[entry.name] | async); track trackByKey($index, option)) {
                    <mat-option
                      [value]="option">
                      {{transformOption(option, entry)}}
                    </mat-option>
                  }
                </div>
              </mat-select>
            </mat-form-field>
          }
          <!-- Date Picker fields -->
          @if (entry.type === 'datePicker') {
            <div>
              <mat-form-field appearance="outline"
                class="filter-form-container-field">
                <mat-label>{{'RANGE'| translate}} {{entry.placeholder | translate}}</mat-label>
                <mat-select [(ngModel)]="rangeControl"
                  (ngModelChange)="setRange($event, entry)"
                  [ngModelOptions]="{standalone: true}">
                  @for (range of ranges; track range) {
                    <mat-option [value]="range.value"
                      >
                      {{range.label}}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              <div class="filter-form-container">
                <mat-form-field appearance="outline"
                  [ngClass]="{'filter-form-container-field-hidden':!displayCustomRange}"
                  class="filter-form-container-field">
                  <mat-date-range-input [rangePicker]="picker"
                    [formGroup]="datesFilterForm[entry.name]">
                    <input matStartDate
                      [formControl]="datesFilterForm[entry.name].controls.start"
                      (dateChange)="onDatePickerChanges(entry)"
                      placeholder="{{'START_DATE' | translate}}">
                      <input matEndDate
                        [formControl]="datesFilterForm[entry.name].controls.end"
                        (dateChange)="onDatePickerChanges(entry)"
                        placeholder="{{'END_DATE' | translate}}">
                      </mat-date-range-input>
                      <mat-datepicker-toggle matSuffix
                      [for]="picker"></mat-datepicker-toggle>
                      <mat-date-range-picker #picker></mat-date-range-picker>
                    </mat-form-field>
                  </div>
                </div>
              }
            }
          </div>
        </form>
      </div>
    }
